module.exports = __webpack_public_path__ + "media/audio2.188d5189.mp3";